import { configureStore } from '@reduxjs/toolkit';

// Minimal empty reducer
const store = configureStore({
  reducer: () => ({}),
});

export default store; 